import { useStatsigClient } from '@statsig/react-bindings';

function useFeatureFlag(gateName) {
    const { client } = useStatsigClient();
    return client.checkGate(gateName);
}

export { useFeatureFlag };
